import React from "react";
import Loader from "./Loader";

const KEY = "ponesi_chunk_recovered";

// A lazy route chunk can 404 after a new deploy (installed PWA holds the old shell). Recover with a
// single hard reload; any further failure shows a retry instead of looping.
export class LazyBoundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false }; }

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error) {
    const stale = /Loading chunk|dynamically imported module|Failed to fetch/i.test(error?.message || "");
    if (stale && !sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center bg-[#F9F9F7]"
          data-testid="chunk-error">
          <p className="font-display font-black text-xl">Nije moguće učitati stranicu</p>
          <button onClick={() => { sessionStorage.removeItem(KEY); window.location.reload(); }}
            data-testid="chunk-retry"
            className="px-5 py-3 rounded-xl bg-brand-red text-white font-bold">Pokušaj ponovo</button>
        </div>
      );
    }
    return <React.Suspense fallback={<Loader />}>{this.props.children}</React.Suspense>;
  }
}
